import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import ArchiveCampaignButton from "./ArchiveCampaignButton";
import CampaignsSelector from "./CampaignsSelector";
import CopyTrackingPixelButton from "./CopyTrackingPixelButton";
import EditCampaignDetailsButton from "./EditCampaignDetailsButton";
import TimeFrameSelector from "./TimeFrameSelector";
import classes from "../../CampaignsDashboard.module.scss";
import { CampaignType } from "../../../../../types/campaignTypes";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";
import { truncateText } from "../../../../../helpers/truncateText";

type CampaignReportDashboardToolbarProps = {
  selectedTimeFrame: string;
  handleTimeFrameChange: (e: any) => void;
  selectedCampaign: CampaignType;
  campaignOptions: SelectOptionType[];
  handleChangeSelectedCampaign: (e: any) => void;
  fetchAndSetCampaigns: () => void;
};

const CampaignReportDashboardToolbar: FC<CampaignReportDashboardToolbarProps> = ({
  selectedTimeFrame,
  handleTimeFrameChange,
  selectedCampaign,
  campaignOptions,
  handleChangeSelectedCampaign,
  fetchAndSetCampaigns,
}) => {
  return (
    <div className={classes.campaignReportDashboardToolbar}>
      <Tooltip title={selectedCampaign.name}>
        <Typography variant="h3">{truncateText(selectedCampaign?.name, 40)}</Typography>
      </Tooltip>

      <div className={classes.toolbarControls}>
        <TimeFrameSelector selectedTimeFrame={selectedTimeFrame} handleTimeFrameChange={handleTimeFrameChange} />

        <CampaignsSelector
          options={campaignOptions}
          selectedCampaign={selectedCampaign}
          handleChangeSelectedCampaign={handleChangeSelectedCampaign}
        />

        <EditCampaignDetailsButton campaignToEdit={selectedCampaign} fetchAndSetCampaings={fetchAndSetCampaigns} />

        <CopyTrackingPixelButton pixelEventId={selectedCampaign.pixel_event_id} />

        <ArchiveCampaignButton campaignToArchive={selectedCampaign} fetchAndSetCampaings={fetchAndSetCampaigns} />
      </div>
    </div>
  );
};

export default CampaignReportDashboardToolbar;
